import $ from 'jquery';

window.dataTableLang = {
		"sEmptyTable":   	"Keine Daten in der Tabelle vorhanden",
		"sInfo":         	"_START_ bis _END_ von _TOTAL_ Einträgen",
		"sInfoEmpty":    	"0 bis 0 von 0 Einträgen",
		"sInfoFiltered": 	"(gefiltert von _MAX_ Einträgen)",
		"sInfoPostFix":  	"",
		"sInfoThousands":  	".",
		"sLengthMenu":   	"_MENU_ Einträge anzeigen",
		"sLoadingRecords": 	"Wird geladen...",
		"sProcessing":   	"Bitte warten...",
		"sSearch":       	"Suchen",
		"sZeroRecords":  	"Keine Einträge vorhanden.",
		"oPaginate": {
			"sFirst":    	"Erste",
			"sPrevious": 	"Zurück",
			"sNext":     	"Nächste",
			"sLast":     	"Letzte"
		},
		"oAria": {
			"sSortAscending":  ": aktivieren, um Spalte aufsteigend zu sortieren",
			"sSortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
		}

	};
window.contactElements = ['','Ort','Telefonnummer', 'Website', 'E-Mail','Facebook', 'Twitter', 'Infomationen'];

$(function () {
    $('.btn-visibility').on('visibility-changed',(e)=>{
        let $btn = $(e.target).find('.fas').addBack('.fas');


        if(e.payload.visible){
            $btn.removeClass('fa-eye-slash');
            $btn.addClass('fa-eye');
        }else{
            $btn.removeClass('fa-eye');
            $btn.addClass('fa-eye-slash');
        }
    });


	$('.dt-buttons').addClass('d-none');
	$('.btn-print').click(function() {
		  $('.buttons-print').trigger( "click" );
	});
	$('.btn-export').click(function() {
		  $('.buttons-excel').trigger( "click" );
	});
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	  $('.'+$(e.relatedTarget).data('tools')).addClass('d-none');
	   $('.'+$(e.target).data('tools')).removeClass('d-none');
	})

	$(document).on('change','.element-type',function(event){
			var type = $(this).val();
			$('.element-value-label').text(contactElements[type]);
	});
	//copy information page
	$(document.body).on('change','.hospital-id-select, .topic-id-select',function() {
    	var el = $(this);
    	if(el.hasClass('hospital-id-select')){
    		$('.topic-id-select').empty();
    		$('.category-id-select').empty();
    	 }
    	else{
        	$('.category-id').empty();
    	 }

    	var targetEl = el.data('target');
    	var url = el.data('route');
    	url = url.replace('::id',el.val());
        $.ajax({
	        url:url,
	        dataType: "json",
	        success: function(data) {
	            $('.'+targetEl).empty();
	            if($.isEmptyObject(data)){
	            	$('.'+targetEl).append("<option value=''>keins Infos vorhanden</option>");
	            	$('.'+targetEl).prop('disabled', true);
	            }
	            else{
	            	$('.'+targetEl).prop('disabled', false);
	            	$('.'+targetEl).append("<option value=''>Bitte wählen</option>");
	            	//$('#date_id').append(data);
	            	$.each(data, function(key, element) {
	            	 	if( typeof element.name != 'undefined')
		            		name = element.name
		            	else
		            		name =  element.title
	            		$('.'+targetEl).append( '<option value="'+element.id+'">'+name+'</option>' );

	            	});
	            }

	        }
	    });
	})
	//end copy information page
	//publish changes
	$(document).on('click','.btn-job',function(event){
		event.preventDefault();
		var el = $(this);
		var url = $(this).data('url');
		var $icon = $('.btn-job').find('i');


		var oldClasses = $icon.prop('class');
		$icon.prop('class','fas fa-sync fa-spin');
		el.prop('disabled',true);
        $('.btn-job').prop('disabled',true);

       	$.ajax({
    		url:url,
    		dataType: "json",
    	    success: function(data) {
    	        	showAlertMessage(data.success?data.success:data.error,data.success?'success':'error');
    	        	if(data.changes)
    	       			$('.publish-changes').removeClass('d-none');
    	   			else
    	    			$('.publish-changes').addClass('d-none');
    	    		if(typeof data.table != 'undefined'){
					    	if ( $('#'+data.table).length ) {
					        	$('#'+data.table).DataTable().ajax.reload();
					        }
					}

    	    	},
            complete: function (){
    		    $icon.prop('class',oldClasses);
                $('.btn-job').prop('disabled',false);
                el.remove();
                el.prop('disabled',false);
            }
    	});
	});
	function checkChange(){
		var url = '/check_changes';
       	$.ajax({
    		url:url,
    		dataType: "json",
    	    success: function(data) {
    	    if(data.changes)
    	       	$('.publish-changes').removeClass('d-none');
    	    else
    	    	$('.publish-changes').addClass('d-none');
    	    }
    	});

	};
	checkChange();
	setInterval(checkChange, 1000*60);
	//end publish changes

	//Expandable table
	function format (el ){
    	var parentTable = el.closest('table');
    	var id = el.data('id');
        var tables = el.data('tables');

        let $html = $('<div></div>');

        for(let i=0;i<tables.length;++i){
            var subTableID = parentTable.attr('id')+'_'+i+'_'+id;
            var subTableClass = parentTable.attr('id')+'-sub-table';

            $html.append('<table cellpadding="5" cellspacing="0" border="0" style="width:100%;" class="table table-hover '+subTableClass+' '+tables[i].type+'-table " data-table-insert-url="'+tables[i].parent+'" data-table-type="'+tables[i].type+'" id="'+subTableID+'">'
                +'<thead style="display: none">'
                +'<tr>'
                +'<th></th>'
                +'<th></th>'
                +'<th></th>'
                +'<th></th>'
                +'<th></th>'
                +'<th></th>'
                +'<th></th>'
                +'</tr>'
                +'</thead> '
                +'</table>');
        }

        return $html;
       }
	function loadTable(el){
    	var parentTable = el.closest('table');
    	var parentTableID = parentTable.attr('id');
        var id = el.data('id');
        var tables = el.data('tables');

        for(let i=0;i<tables.length;++i){

            let tableURL = tables[i].table;
            let orderURL = tables[i].order;
            let parentURL = tables[i].parent;

            tableURL = tableURL.replace('::id',id);
            orderURL = orderURL.replace('::id',id);

            var columns = [];
            if(parentTable.attr('id')=='phases_table')
                columns = [	{data: 'title', name: 'title', width:'35%'},
                    {data: 'order', name: 'order', width:'0%'},
                    {data: 'icons_col', name: 'icons_col', orderable: false, searchable: false, width:'7%'},
                    {data: 'variant_type', name: 'variant_type', orderable: false, searchable: false, width:'8%',render: function ( data, type, row ) {
                            return data=='App\\Models\\InformationMoment'?'Information':(data=='App\\Models\\ActionMoment'?'Aktion':'Basis');
                        }},
                    {data: 'info_element_title', name: 'info_element_title', orderable: false, searchable: false, width:'23%'},
                    {data: 'time_trigger', name: 'time_trigger', orderable: false, searchable: false, width:'17%',render: function ( data, type, row ) {
                            return data?Math.abs(row.start_time)+' Tage '+(row.start_time<0?'vor':'nach')+' Operation':'';
                        }},
                    {data: 'action', name: 'action', orderable: false, searchable: false, width:'10%'}
                ];
            else if(parentTable.attr('id')=='contact_informations_table')
                columns = [ {data: 'element', name: 'caption',width:'90%'},
                    {data: 'order', name: 'order'},
                    {data: 'action', name: 'action', orderable: false, searchable: false,width:'10%'}
                ];
            else
                columns = [ {data: 'detailsIcon', name: 'detailsIcon', width:'2%'},
                    {data: 'order', name: 'order', width:'0%'},
                    {data: 'title', name: 'title', width:'87%'},
                    {data: 'action', name: 'action', orderable: false, searchable: false, width:'10%'}
                ];

            $('#'+parentTableID+'_'+i+'_'+id).DataTable({
                language: dataTableLang,
                lengthMenu: [ [25, 50, 100, -1], [25, 50, 100, "All"] ],
                processing: true,
                serverSide: true,
                searching: false,
                autoWidth:false,
                ajax: tableURL,
                columns: columns,
                rowReorder: {
                    dataSrc: 'order',
                    selector: 'span.btn-reorder'
                },
                columnDefs: [
                    { targets: 1, visible: false }
                ],
                dom: 'frt',
                order: [[1,'asc']],
            }).on( 'row-reorder', function ( e, diff, edit ) {


		    if(edit.newTable){

                var rowData = edit.triggerRow.data();

                var url= edit.insertData.table.data('table-insert-url');
                url = url.replace('::id',rowData['id']);
                url = url.replace('::position',edit.insertData.order);

                $.ajax({
                    url:url,
                    dataType: "json",
                    success: function(data) {
                        //showAlertMessage(data.success?data.success:data.error,data.success?'success':'error');
                        return;
                    }
                });


            }else{
                for ( var i=0, ien=diff.length ; i<ien ; i++ ) {
                    var url= orderURL;
                    var stable = $(this).closest('table').DataTable();
                    var rowData = stable.row( diff[i].node ).data();
                    if(diff[i].oldData!=diff[i].newData){
                        url = url.replace('::orderid',rowData['id']);
                        url = url.replace('::newOrder',diff[i].newData);
                        // console.log(diff[i].newData);
                        $.ajax({
                            url:url,
                            dataType: "json",
                            success: function(data) {
                                //showAlertMessage(data.success?data.success:data.error,data.success?'success':'error');
                                return;
                            }
                        });
                    }
                }
            }


            });
        }

    }

    $(document).on('click', '.expandable-table .details-icon', function () {
        var parentTable = $(this).closest('table');
        var tr = $(this).closest('tr');
        var row = $('#'+parentTable.attr('id')+'').DataTable().row( tr );
        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tr.find('.btn-reorder').show();
            $(this).removeClass('fa-minus');
            $(this).addClass('fa-plus');
        }
        else {
            // Open this row
            row.child( format($(this))).show();
            tr.addClass('shown');
            tr.find('.btn-reorder').hide();
            $(this).removeClass('fa-plus');
            $(this).addClass('fa-minus');
            loadTable($(this));
        }
    } );
	//End expandable table

	$(document.body).on('click','.date_create, .delete_date, .loadform, .add_accompaniment',function(e){
		var url = $(this).data('href');
		//if($('#copyModal').length)
		//	$('#copyModal').remove();
		loadModal(url, e.target);
	});
	$(document).on('click','.delete-media-btn',function(event){
		event.preventDefault();
		var url = $(this).attr('href');
		$.ajax({
			url: url,
			success: function(data) {
				showAlertMessage(data.success?data.success+12:data.error,data.success?'success':'error');
				if(data.success){
					if(typeof data.id != 'undefined'){
						$('.media-input').removeClass('d-none');
						$('.media-thumb-'+data.id).remove();
				    }
				}

			},
			error: function(xhr) {

			}
		});
	})


	/*$(document.body).on('click','.date_create, .delete_date, .loadform, .add_accompaniment',function(e){
		var url = $(this).data('href');
		loadModal(url);
	});	*/


	 $(document).on('submit','.ajax-form',function(event){

        var $form = $(this);
        event.preventDefault();
        var url = $form.attr('action');
        //formdata = $form.serializeArray();
        var formdata = new FormData($form[0]);
        var $overlay = $('<div class="overlay"><i class="fas fa-2x fa-sync fa-spin"></i></div>');
        $form.find('.has-error').removeClass('has-error');
        $form.find('.help-block').remove();
        $form.append($overlay);

		$.ajax({
			url: url,
			type: 'post',
			data: formdata,
			processData: false,
		    contentType: false,
			success: function (data) {
					// success callback
				    $('.modal').fadeOut().remove();
				    $('body').removeClass('modal-open');
				    $('.modal-backdrop').remove();
				    if(typeof data.js_alert != 'undefined')
				    	alert(data.success);
				    else
				    	showAlertMessage(data.success?data.success:data.error,data.success?'success':'error');
				    if(data.success){

                        if(typeof data.event != 'undefined'){
                            $(document).trigger(data.event, data.eventParams || undefined);
                        }

				    	if(typeof data.table != 'undefined'){
					    	if ( $('#'+data.table).length ) {
					        	$('#'+data.table).DataTable().ajax.reload();
					        }
					    	if($('.search-c-tariffs-form').length)
					    		$('.search-c-tariffs-form').submit();

				    	}
				    	if(typeof data.disabledSubmit != 'undefined'){
				    		$('.loadform').addClass('hidden');
				    	}
				    	if(typeof data.disabledSubmitType != 'undefined'){
				    		$('.loadform-'+data.disabledSubmitType).addClass('hidden');
				    	}
				    	if(typeof data.log != 'undefined'){
				    		addHistory(data.log);
				    	}
				    	if(data.reload){
				    	    location.reload();
                        }


				    }
				},
		  error: function (jqXHR, exception) {
				  // error callback
				  if(jqXHR.status == 422){
					  var errors = jqXHR.responseJSON;
					  $.each(errors.errors, function(key, error){
						  $form.find('label[for='+key+']').parents('.form-group').addClass('has-error');
						  $form.find('label[for='+key+']').parents('.form-group').append('<div class="help-block">'+error+'</div>');
					      if($form.find('label[for='+key+']').parents('.form-group').find('.field'))
					    	  $form.find('label[for='+key+']').parents('.form-group').find('.field').append('<div class="help-block">'+error+'</div>');
					      else
					           $form.find('label[for='+key+']').parents('.form-group').append('<div class="help-block">'+error+'</div>');
					            });

					  showAlertMessage('Die rot markierten Felder müssen ausgefüllt werden.','error');
					  $("html, body").animate({ scrollTop: 0 }, "slow");
					            return false;
				    }
				 },
            complete: function (){
                    $overlay.remove();
                }
			},);
	 });


	 $(document).on('change','.table-checkbox input:checkbox,.table-checkbox input:radio',function(event){
			updateCounter();
		});
	$(document).on('change','.table-checkbox .select-all',function(event){
			var checkthis = $(this);
			var checkboxes = $('.table-checkbox').find("input[name='id[]']");

			if(checkthis.is(':checked')) {
				checkboxes.prop('checked', true);
			} else {
				checkboxes.prop('checked', false);
			}
	        updateCounter();
		});

});
function loadModal(url, target = document.body){
	$('.modal').remove();
	$.ajax({
		url: url,
		data: {},
		dataType: 'html',
		complete: function (jqXHR, textStatus) {
			      // callback
			      },
		success: function (data, status, xhr) {
                if(xhr.getResponseHeader('Content-Type') == 'application/json'){
                    try{
                        data = JSON.parse(data);
                    }catch (e){
                        showAlertMessage('Fehlerhafte Antwort vom Server.','error');
                        return;
                    }

                    if(typeof data.table != 'undefined'){
                        if ( $('#'+data.table).length ) {
                            $('#'+data.table).DataTable().ajax.reload();
                        }
                        if($('.search-c-tariffs-form').length)
                            $('.search-c-tariffs-form').submit();

                    }

                    if(typeof data.event != 'undefined'){
                        $(target).trigger(data.event);
                    }
                    return;
                }
			     // success callback
			     $('body').append(data);
			     var $modal = $('.modal');
			     $modal.modal({
				        'backdrop':'static',
			        });
			     $modal.modal('show');
			    },
			   error: function(xhr){
         		if(xhr.status == 403)
         			showAlertMessage('Diese Aktion ist nicht autorisiert.','error');
     			}
			 });
}
function showAlertMessage(msg,type){
	toastr.options = {"positionClass": "toast-top-center"};
	if(type == 'success')
		toastr.success(msg);
	else
		toastr.error(msg);
	if($('body').hasClass('modal-open') && $('#modal_alerts').length)
		showModalAlertMessage(msg,type);
	else{
	$('.alert-success').hide();
	$('.alert-error').hide();
	$('#page_alerts').append("<div class='clearfix'></div>"+
							"<div  class='alert alert-"+type+"' role='alert'>"+
						    "<a href='#' class='close'  onClick=\"$('.alert-"+type+"').hide();\" aria-label='close'>&times;</a>"+
						    msg+
							"</div>");
	if(type !='error'){
		setTimeout(function() {
			$('.alert-'+type+'').hide()
	    }, 30000);
	}
	}
}
function showModalAlertMessage(msg,type){
	$('.alert-success').hide();
	$('.alert-error').hide();
	$('#modal_alerts').append("<div class='clearfix'></div>"+
							"<div  class='alert alert-"+type+"' role='alert'>"+
						    "<a href='#' class='close'  onClick=\"$('.alert-"+type+"').hide();\" aria-label='close'>&times;</a>"+
						    msg+
							"</div>");
	if(type !='error'){
		setTimeout(function() {
			$('#modal_alerts .alert-'+type+'').hide()
	    }, 30000);
	}
}
function showAlertDialog(title, message){
	  var modal = $('#alert-modal');
	  modal.find('.modal-title').text(title);
	  modal.find('.modal-body').html(message);
	  modal.modal('show');
}
function addHistory(log){
	$hisItem = '<li class="time-label">'+
					'<span class="minsk">'+log.date+'</span>'+
				'</li>'+
				'<li>'+
					'<i class="fa fa-circle bg-blue" title=""></i>'+
					 '<div class="timeline-item">'+
					 	'<span class="time"><i class="fa fa-clock-o"></i>'+log.date+'</span>'+
						'<h3 class="timeline-header">'+log.description+'</h3>'+
					'</div>'+
				'</li>';
	$('.history-box .timeline').append($hisItem);
	$('.current-status').text(log.currentStatus);
}

function showMadal(event){
	event.preventDefault();
	$('#reading-modal').modal('show');

}
